import {Box, Button, Modal, Typography} from "@mui/material";
import React from "react";

interface CalculationCompleteModalProps {
  open: boolean;
  onClose: () => void;
}

export const CalculationCompleteModal: React.FC<CalculationCompleteModalProps> = ({ open, onClose }) =>
  <Modal open={open} onClose={onClose}>
    <Box sx={{
      width: '50%',
      margin: '10vh auto',
      maxWidth: 800,
      maxHeight: '90vh',
      background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
      borderRadius: 4,
      border: '1px solid rgba(0,0,0,0.08)',
      boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
      overflow: 'hidden',
    }}>
      <Box sx={{margin: "auto"}} p={2}>
        <Typography variant="h6" sx={{ mb: 2 }}>Calculation Complete</Typography>
        <Box sx={{ textAlign: 'right', mt: 2 }}>
          <Button onClick={onClose} variant="outlined">Close</Button>
        </Box>
      </Box>
    </Box>
  </Modal>